import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import BookingFilter from "./BookingFilter";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import BookingList from "./BookingList";
import styled from "styled-components";
import DeleteBooking from "../DeleteBooking";
import MyBookingMultiDeleteDialog from "../booking-instruments/my-bookings/my-booking-list-view/my-booking-multi-delete-button/MyBookingMultiDeleteDialog";
import BookingNotificationStatus from "../booking-calendars/booking-notification-status/BookingNotificationStatus";
import { timeoutCallbackFactory } from "../booking-calendars/booking-notification-status/timeoutCallbackFactory";
import {
  allTableColumn,
  DEFAULT_COLUMNS,
  DEFAULT_FILTER,
  DURATION,
  EQUIPMENT_BASED_DEFAULT_SHOW_COLUMNS,
  GRID_VIEW,
  LIST_VIEW,
  MY_LAB
} from "../../constants";
import { snackbarService } from "@one/web-components/dist/index.cjs.js";
import { debounce, filter, find, sortBy } from "lodash";
import { PaginationContext } from "../../components/shared/pagination/PaginationContext";
import { useSelector } from "react-redux";
import {
  convertStrToObjColumns,
  convertToCameCase,
  getAdjustedWeekRangeISOString
} from "../../utils/helpers/text";
import BookingGrid from "./BookingGrid";
import { useParams } from "react-router-dom";
import { BOOKING_STORAGE_KEYS, getPersistedFilter, setPersistedFilter } from "../../utils/store/bookingFilterPersistence";
import { generateViewKey, resetViewState } from "../bookings/ViewSwitchingUtils";
import EquipmentBookingList from "./EquipmentBookingList";
import { withApollo } from "react-apollo";
import { SharedFilterProvider } from "../bookings/SharedFilterContext";
import { getColumnObj } from "../equipment-list/EquipmentHelper";
import { getAllMasterFilterData } from "../equipment-list/LoadEquipmentService";
const autoGroupColField = "equipment_model";

const MainViewStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  padding-top: 8px;
  padding-bottom: 8px;
`;

const bookingCallbackFactory = ({
  dispatchAction,
  setOpenMultiDeleteDialog,
  setStatus,
  setIsDropBooking,
  setIsDialogOpen,
  setTempRowData,
  triggerFetch
}) => {
  return debounce((data) => {
    if (data?.data?.onUpdateBookingCommand?.processingResult !== "CHECK_IN_SUCCEEDED") {
      const result = data?.data?.onUpdateBookingCommand?.processingResult === "ALL_SUCCEEDED"
        ? null
        : {
          type: "error",
          message: "There were problems with booking, please check detailed statuses.",
          duration: DURATION,
        };
      result && snackbarService.show(result);
      setStatus(false);
      setOpenMultiDeleteDialog(false);
      setIsDropBooking(false);
      setIsDialogOpen(false);
      triggerFetch(false);
      setTempRowData([]);
      triggerFetch(true);
      dispatchAction({
        type: "clearAll",
      });
    }
  }, 2500);
};

function MyBooking({ subscriptionStatus, setSubscriptionStatus, setPopupEnableStatus, client, groupName, isGroupView }) {
  const { trackPageView } = useMatomo();
  const { EventID } = useParams();
  const [eventID, setEventID] = useState(null);

  useEffect(() => {
    trackPageView({
      documentTitle: "My bookings",
      href: `${window.location?.origin}/Mybookings`,
    });
    if (EventID) {
      setEventID(EventID);
      setView(GRID_VIEW);
    }
    // eslint-disable-next-line
  }, []);
  const user = useSelector((store) => store.user);
  const [resetAll, setResetAll] = useState(false);
  const [disableResetAll, setDisableResetAll] = useState(true);
  const [selectedEquipment, setSelectedEquipment] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');

  const [selectedDateRange, setSelectedDateRange] = useState(() => {
    const defaultDateRange = [
      getAdjustedWeekRangeISOString("start", user.timezone),
      getAdjustedWeekRangeISOString("end", user.timezone),
    ];
    return defaultDateRange;
  });

  const [tempRowData, setTempRowData] = useState([]);
  const [isDropBooking, setIsDropBooking] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [openMultiDeleteDialog, setOpenMultiDeleteDialog] = useState(false);
  const [rowEquipmentId, setRowEquipmentId] = useState(null);
  const [shouldFetchData, triggerFetch] = useState(false);

  const { dispatchAction } = useContext(PaginationContext);
  const [status, setStatus] = useState(false);

  const [view, setView] = useState(() => {
    return getPersistedFilter(BOOKING_STORAGE_KEYS.VIEW, GRID_VIEW);
  });
  const [showAdvanceFilter, setShowAdvanceFilter] = useState(() => {
    return getPersistedFilter(BOOKING_STORAGE_KEYS.SHOW_ADVANCE_FILTER, false);
  });
  const [isEquipmentView, setIsEquipmentView] = useState(() => {
    return getPersistedFilter(BOOKING_STORAGE_KEYS.IS_EQUIPMENT_VIEW, false);
  });
  const [displayPreset, setDisplayPreset] = useState(() => {
    return getPersistedFilter(BOOKING_STORAGE_KEYS.DISPLAY_PRESET, null);
  });
  const [listGroupByView, setListGroupByView] = useState(() => {
    return getPersistedFilter(BOOKING_STORAGE_KEYS.LIST_GROUP_BY_VIEW, 'BOOKING');
  });
  const [savedFilter, setSavedFilter] = useState(() => {
    return isGroupView ? groupName : getPersistedFilter(BOOKING_STORAGE_KEYS.SAVED_FILTER, MY_LAB);
  });
  const [signeeFilter, setSigneeFilter] = useState(() => {
    return getPersistedFilter(BOOKING_STORAGE_KEYS.SIGNEE_FILTER, "");
  });
  const [showFilters, setShowFilters] = useState(() => {
    return getPersistedFilter(BOOKING_STORAGE_KEYS.SHOW_FILTERS, false);
  });

  const [showInvalidFilter, setShowInvalidFilter] = useState(false);
  const [showSideBar, setShowSideBar] = useState(false);
  const [currentSideBarPanel, setCurrentSideBarPanel] = useState("");
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [isColumnActive, setIsColumnActive] = useState(false);

  const getDefaultEquipmentBasedColumns = () => {
    if (listGroupByView !== 'NONE') return DEFAULT_COLUMNS
    const defaultCols = structuredClone(DEFAULT_COLUMNS)
    defaultCols.displayDefinition.showColumns = EQUIPMENT_BASED_DEFAULT_SHOW_COLUMNS
    return defaultCols
  }
  const [dataModel, setDataModel] = useState([]);
  const [myLabFilter, setMyLabFilter] = useState(null);
  const [masterDataFilters, setMasterDataFilters] = useState({});
  const [userDisplayColumnMaster, setUserDisplayColumnMaster] = useState([]);
  const [userFilters, setUserFilters] = useState([]);
  const [lastFavFilter, setLastFavFilter] = useState(DEFAULT_FILTER);
  const [lastDisplayColumns, setLastDisplayColumns] = useState(() => getDefaultEquipmentBasedColumns());
  const localUserFilters = useRef(userFilters);
  const [defaultShowColumns, setDefaultShowColumns] = useState(() => getDefaultEquipmentBasedColumns());

  // Effect to handle invalid filter display with delay
  useEffect(() => {
    if (groupName !== savedFilter && isGroupView) {
      const timeoutId = setTimeout(() => {
        setShowInvalidFilter(true);
      }, 2000); // 1 second delay

      return () => clearTimeout(timeoutId);
    } else {
      setShowInvalidFilter(false);
    }
  }, [groupName, savedFilter, isGroupView]);

  // Improved localStorage persistence with batching
  useEffect(() => {
    if (isGroupView) {
      return;
    }

    const timeoutId = setTimeout(() => {
      const filtersToSave = {
        [BOOKING_STORAGE_KEYS.SAVED_FILTER]: savedFilter,
        [BOOKING_STORAGE_KEYS.SIGNEE_FILTER]: signeeFilter,
        [BOOKING_STORAGE_KEYS.SHOW_FILTERS]: showFilters,
        [BOOKING_STORAGE_KEYS.SHOW_ADVANCE_FILTER]: showAdvanceFilter,
        [BOOKING_STORAGE_KEYS.SEARCH_QUERY]: searchQuery,
        [BOOKING_STORAGE_KEYS.SELECTED_DATE_RANGE]: selectedDateRange,
        [BOOKING_STORAGE_KEYS.VIEW]: view,
        [BOOKING_STORAGE_KEYS.IS_EQUIPMENT_VIEW]: isEquipmentView,
        [BOOKING_STORAGE_KEYS.LIST_GROUP_BY_VIEW]: listGroupByView,
        [BOOKING_STORAGE_KEYS.DISPLAY_PRESET]: displayPreset,
      };

      Object.entries(filtersToSave).forEach(([key, value]) => {
        try {
          setPersistedFilter(key, value);
        } catch (error) {
          console.warn('Failed to persist filter:', key, error);
        }
      });
    }, 100);

    return () => clearTimeout(timeoutId); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedFilter, signeeFilter?.userId, showFilters, showAdvanceFilter, searchQuery, selectedDateRange, view, isEquipmentView, displayPreset, listGroupByView, isGroupView]);

  const loadFilterData = useCallback(async () => {
    if (!user?.site || !user?.id) return;

    try {
      const { masterFiltersList, myLabFilterMaster, userDetail, userDisplayColumnMaster } = await getAllMasterFilterData({
        client: client,
        site: user.site,
        userID: user.id,
        cachedUser: user
      });

      setMyLabFilter(myLabFilterMaster);
      setMasterDataFilters(() => masterFiltersList);
      setUserDisplayColumnMaster(userDisplayColumnMaster);
      setLastFavFilter(() => userDetail?.lastFavFilter);
      setLastDisplayColumns(() => userDetail?.lastDisplayColumns);
      const withFilterId = (userDetail?.userFilters || []).map((filter) => {
        return {
          ...filter,
          filterDefinition: {
            ...filter?.filterDefinition,
            filterId: `f_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
          },
        };
      });

      setUserFilters(withFilterId);

      const defaultShowCols = filter(allTableColumn(listGroupByView === 'NONE'), { show: true });

      setDefaultShowColumns(() => {
        return defaultShowCols?.map((value) => {
          return getColumnObj(value, [], convertToCameCase(autoGroupColField)); // TODO
        });
      });

    } catch (error) {
      console.error("Error loading filter data:", error);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    loadFilterData();
  }, [loadFilterData]);

  const bookingCallback = useMemo(() => bookingCallbackFactory({
    dispatchAction,
    setOpenMultiDeleteDialog,
    setStatus,
    setIsDropBooking,
    setIsDialogOpen,
    setTempRowData,
    triggerFetch,
  }), [dispatchAction]);

  useEffect(() => {
    if (subscriptionStatus) {
      let result;
      if (subscriptionStatus?.processingResult === "ALL_SUCCEEDED") {
        result = {
          type: "success",
          message: "Booking confirmed successfully!",
          duration: DURATION,
        };
      } else if (
        subscriptionStatus?.processingResult === "SOME_FAILED" ||
        subscriptionStatus?.processingResult === "ALL_FAILED"
      ) {
        result = {
          type: "warning",
          message: `There was an issue with your equipment booking timeslots(s). Please check "My bookings" for more information.`,
          duration: DURATION,
        };
      } else {
        result = {
          type: "error",
          message: "There were problems with bookings, please check detailed statuses.",
          duration: DURATION,
        };
      }
      snackbarService.show(result);
      setSubscriptionStatus(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionStatus]);

  // Save view preference to localStorage
  useEffect(() => {
    localStorage.setItem("myBooking_view", view);
  }, [view]);

  // Save equipment view preference to localStorage
  useEffect(() => {
    localStorage.setItem("myBooking_isEquipmentView", isEquipmentView.toString());
  }, [isEquipmentView]);

  useEffect(() => {
    // Reset state when switching views to ensure clean data load
    resetViewState({
      setTempRowData,
      setSelectedEquipment
    }, dispatchAction);

    // Log view switch for debugging
    // logViewSwitch(view, isEquipmentView, savedFilter, signeeFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view, isEquipmentView, listGroupByView, savedFilter, signeeFilter?.userId, setTempRowData, setSelectedEquipment, dispatchAction]);

  useEffect(() => {
    const unorderedHidenColumn = [];
    const orderedShowColumns = sortBy(
      convertStrToObjColumns(lastDisplayColumns)?.displayDefinition?.showColumns,
      ["order"],
      ["asc"]
    );

    allTableColumn(listGroupByView === 'NONE')?.forEach((value, _index) => {
      const obj = find(orderedShowColumns, {
        key: value?.key,
      });
      if (!obj) {
        unorderedHidenColumn.push(value);
      }
    });

    const redefinedColumns = [...orderedShowColumns, ...unorderedHidenColumn]?.map((value) => {
      return getColumnObj(value, masterDataFilters, convertToCameCase(autoGroupColField));
    });
    const defaultShowCols = filter(allTableColumn(listGroupByView === 'NONE'), { show: true });
    setDefaultShowColumns(() => {
      return defaultShowCols?.map((value) => {
        return getColumnObj(value, masterDataFilters, convertToCameCase(autoGroupColField));
      });
    });
    setDataModel([...redefinedColumns]);
    // eslint-disable-next-line
  }, [masterDataFilters]);

  const listViewDisplay = () => {
    const componentKey = generateViewKey(view, true, savedFilter, signeeFilter?.userId || 'all', listGroupByView, displayPreset?.label, currentSideBarPanel);
    const listCommonProps = {
      selectedDateRange,
      setDisableResetAll,
      setSelectedDateRange,
      setSelectedEquipment,
      selectedEquipment,
      showAdvanceFilter,
      resetAll,
      setSearchQuery,
      searchQuery,
      setResetAll,
      setIsDropBooking,
      setIsDialogOpen,
      setOpenMultiDeleteDialog,
      setRowEquipmentId,
      tempRowData,
      setTempRowData,
      setPopupEnableStatus,
      savedFilter,
      setSavedFilter,
      signeeFilter,
      setSigneeFilter,
      displayPreset, dataModel,
      setDisplayPreset, defaultShowColumns, shouldFetchData,
      userFilters, setUserFilters, lastDisplayColumns, setLastDisplayColumns, lastFavFilter, setLastFavFilter,
      userDisplayColumnMaster, setUserDisplayColumnMaster, isColumnActive, setIsColumnActive, localUserFilters,
      myLabFilter, setShowSideBar, showSideBar, currentSideBarPanel, setCurrentSideBarPanel, isFilterActive, setIsFilterActive
    };
    if (listGroupByView === 'NONE' || listGroupByView === 'EQUIPMENT') {
      return <EquipmentBookingList
        key={componentKey}
        {...listCommonProps}
      />
    }
    return <BookingList
      key={componentKey}
      {...listCommonProps}
    />;
  };


  return (
    <SharedFilterProvider client={client} user={user}>
      <MainViewStyled>
        <>
          <BookingFilter
            resetAll={resetAll}
            setResetAll={setResetAll}
            showAdvanceFilter={showAdvanceFilter}
            setShowAdvanceFilter={setShowAdvanceFilter}
            setSelectedEquipment={setSelectedEquipment}
            selectedDateRange={selectedDateRange}
            setSelectedDateRange={setSelectedDateRange}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            tempRowData={tempRowData}
            setTempRowData={setTempRowData}
            disableResetAll={disableResetAll}
            setDisableResetAll={setDisableResetAll}
            view={view}
            setView={setView}
            isEquipmentView={isEquipmentView}
            setIsEquipmentView={setIsEquipmentView}
            savedFilter={savedFilter}
            setSavedFilter={setSavedFilter}
            displayPreset={displayPreset}
            setDisplayPreset={setDisplayPreset}
            listGroupByView={listGroupByView}
            setListGroupByView={setListGroupByView}
            signeeFilter={signeeFilter}
            setSigneeFilter={setSigneeFilter}
            showFilters={showFilters}
            setShowFilters={setShowFilters}
            groupName={groupName}
            isGroupView={isGroupView}
            showInvalidFilter={showInvalidFilter}
            userFilters={userFilters}
            userDisplayColumnMaster={userDisplayColumnMaster}
            myLabFilter={myLabFilter}
            showSideBar={showSideBar}
            setShowSideBar={setShowSideBar}
            currentSideBarPanel={currentSideBarPanel} setCurrentSideBarPanel={setCurrentSideBarPanel}
            isFilterActive={isFilterActive} setIsFilterActive={setIsFilterActive} isColumnActive={isColumnActive} setIsColumnActive={setIsColumnActive}
          />

          {view === LIST_VIEW ? (
            listViewDisplay()
          ) : (
            <BookingGrid
              viewData={view}
              setViewData={setView}
              eventID={eventID}
              isEquipmentView={isEquipmentView}
              setIsEquipmentView={setIsEquipmentView}
              listGroupByView={listGroupByView}
              setListGroupByView={setListGroupByView}
              savedFilter={savedFilter}
              setSavedFilter={setSavedFilter}
            />
          )}

          <BookingNotificationStatus
            tryTimes={3}
            timeout={5 * 60 * 1000}
            onTimeoutCallback={timeoutCallbackFactory()}
            onBookingCallback={bookingCallback}
          />

          {isDropBooking && (
            <DeleteBooking
              setIsDropBooking={setIsDropBooking}
              setIsDialogOpen={setIsDialogOpen}
              isDialogOpen={isDialogOpen}
              item={rowEquipmentId}
              status={status}
              setStatus={setStatus}
              triggerFetch={triggerFetch}
            />
          )}

          {openMultiDeleteDialog && (
            <MyBookingMultiDeleteDialog
              openMultiDeleteDialog={openMultiDeleteDialog}
              setOpenMultiDeleteDialog={setOpenMultiDeleteDialog}
              selectedEquipment={selectedEquipment}
              setSelectedEquipment={setSelectedEquipment}
              status={status}
              setStatus={setStatus}
            />
          )}
        </>
      </MainViewStyled>
    </SharedFilterProvider>
  );
}

export default withApollo(MyBooking);
